"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeNumeral = void 0;
const numeral_1 = __importDefault(require("numeral"));
const full_console_log_1 = require("./full-console-log");
const safeNumeral = (value) => {
    if (isNaN(value) || !Number.isFinite(value)) {
        throw new Error('Invalid number to convert to numeral: "' + (0, full_console_log_1.toString)(value) + '"');
    }
    const response = (0, numeral_1.default)(value);
    if (response.value() === null) {
        throw new Error("The number has converted into an invalid numeral: value = '" +
            (0, full_console_log_1.toString)(value) +
            "', numeral = '" +
            (0, full_console_log_1.toString)(response) +
            "'");
    }
    return response;
};
exports.safeNumeral = safeNumeral;
//# sourceMappingURL=numeral.js.map